<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><router-link to="">会员风采</router-link></li> -->
                <li class="currentNode"><a>精彩瞬间</a></li>
            </ul>
            <div class="page-main">
                <h3>精彩瞬间</h3>
                <el-radio-group v-model="pageType" @input="changePageType" style="margin-bottom: 30px;">
                    <el-radio :label="1">单张显示</el-radio>
                    <el-radio :label="2">活动显示</el-radio>
                </el-radio-group>
                <div v-if="pageType == '1'">
                    <div v-for="(highLight, index) in highLightList" :key="highLight.Id" class="highLightItem">
                        <h3 class="group_title">
                            <span>{{ highLight.Name }}</span>
                            <a>共{{ highLight.ImageNum }}张</a>
                        </h3>
                        <div class="swipper-div">
                            <div class="swipper-prev" @click="prev(index)">
                                <p> &lt; </p>
                            </div>
                            <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
                            <div class="swiper-container">
                                <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                                    <swiper-slide v-for="image in highLight.ListImage" :key="image.ImageId">
                                            <!-- <img :src="image.ImageUrl" :alt="image.Title" class="highLightImage" /> -->
                                            <el-image
                                                :src="image.ImageUrl"
                                                :preview-src-list="highLight.ImageUrlList"
                                                :initial-index="image.ImageList"
                                                class="highLightImage"
                                                @click="clickImage(image.Title, image.initialIndex, highLight.ListImage)">
                                            </el-image>
                                    </swiper-slide>
                                </swiper>
                            </div>
                            <!-- <div class="swiper-button-next" slot="button-next"></div> -->
                            <div class="swipper-next " @click="next(index)">
                                <p> &gt; </p>
                            </div>
                        </div>
                    </div>
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            @current-change="handleCurrentChange">
                    </el-pagination>
                </div>          
                <div v-if="pageType == '2'">
                    <ul class="highLight-ul">
                        <li class="highLight-item" v-for="highLight in highLightListAll" :key="highLight.Id" @click="goDetail(highLight)">
                            <img
                                :src="highLight.ImageUrl"
                            />
                            <el-tooltip :content="highLight.Name" placement="top">
                                <p class="ellipsis_one">{{ highLight.Name }}</p>
                            </el-tooltip>
                        </li>
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="totalAll"
                        :current-page="currentPageAll"
                        :page-size="pageSizeAll"
                        @current-change="handleCurrentChangeAll">
                    </el-pagination>
                </div>
                
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getJingcaiList,
    getJingcaiGroupList
} from '@services/indexService.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
    name:"",
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            pageType: 2,
            highLightList: [],
            highLightListAll:[],
            total: 0,
            currentPage: 1,
            pageSize: 8,
            totalAll: 0,
            currentPageAll: 1,
            pageSizeAll: 12,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 10,
                grabCursor: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
            this.currentPageAll = Number(this.$route.query.page);
        }
        this.getJingcaiList();
        this.getJingcaiGroupList();
    },
    methods: {
        getJingcaiList() {
            let params = {
                current: this.currentPageAll,
                size: this.pageSizeAll,
            };
            getJingcaiList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.highLightListAll = res.Data;
                    this.totalAll = res.Count;
                    this.highLightListAll.map(item => {
                        item.ImageList = 1;
                        item.ImageUrlList = [item.ImageUrl];
                        console.log( item.ImageUrlList)
                        return item;
                    })
                } else {
                    this.$message.error("精彩瞬间请求失败");
                }
            })
        },
        getJingcaiGroupList () {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
            };
            getJingcaiGroupList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.highLightList = res.Data;
                    this.total = res.Count;
                    this.highLightList.map((item,index) => {
                        let imageList = [];
                        item.ListImage.forEach(image => {
                            imageList.push(image.ImageUrl)
                        })
                        item.ImageList = index;
                        item.ImageUrlList = imageList;
                        item.ImageNum = imageList.length;
                        return item;
                    })
                } else {
                    this.$message.error("精彩瞬间请求失败");
                }
            })
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/high-light-detail',
                query: {
                    id: data.Id,
                    title: data.Name,
                    page: this.currentPage,
                    radio: this.pageType
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            console.log(pageNum)
            this.currentPage = pageNum;
            this.getJingcaiGroupList();
        },
        handleCurrentChangeAll(pageNum) {
            this.currentPageAll = pageNum;
            this.getJingcaiList();
        },
        prev(index){
            console.log(this.$refs.mySwiper, index)
            this.$refs.mySwiper[index].swiper.slidePrev();
        },
        next(index) {
            this.$refs.mySwiper[index].swiper.slideNext();
        },
        changePageType() {
            
        },
        cancelStyle(){
            document.body.style='overflow:auto'; 
        },
        clickImage(title, index, imageGroup) {
            this.cancelStyle();
            let name =title;
            this.srcList2 = this.srcList;
            this.lastMovedIndex = index; // 更新上一次移动的索引
            let _this = this;
            this.$nextTick(async () => {
                let oldDom = document.getElementsByClassName(
                    "el-image-viewer__wrapper"
                )[0];
                let newDom = document.createElement("p");
                newDom.className = 'fix_image_name';
                console.log("name", name);
                let newContent = document.createTextNode(name);
                newDom.appendChild(newContent);
                oldDom.appendChild(newDom);
                let next = document.getElementsByClassName(
                    "el-image-viewer__next"
                )[0];
                let prev = document.getElementsByClassName(
                    "el-image-viewer__prev"
                )[0];
                next.addEventListener("click", function () {
                    let imgDiv = document.getElementsByClassName(
                        "el-image-viewer__canvas"
                    )[0];
                    let imageUrl = imgDiv.getElementsByTagName("img")[0].src;
                    let currentName = imageGroup.filter(item => item.ImageUrl == imageUrl)[0].Title;
                    let imgTitle = oldDom.getElementsByTagName("p")[0];
                    imgTitle.innerText = currentName;
                });
                prev.addEventListener("click", function () {
                    let imgDiv = document.getElementsByClassName(
                        "el-image-viewer__canvas"
                    )[0];
                    let imageUrl = imgDiv.getElementsByTagName("img")[0].src;
                    let currentName = imageGroup.filter(item => item.ImageUrl == imageUrl)[0].Title;
                    let imgTitle = oldDom.getElementsByTagName("p")[0];
                    imgTitle.innerText = currentName;
                });
            });
    
        },
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.highLight-ul{
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.highLight-item{
    margin-bottom: 20px;
    margin-right: 20px;
    width: 290px;
    cursor:pointer;
}
.highLight-ul .highLight-item:nth-child(4n) {
    margin-right:0;
}
.highLight-item img {
    width: 290px;
    height: 164px;
}
.highLight-item p {
    color: #262626;
    font-size: 16px;
    padding: 10px 0;
}
.swipper-div {
    padding: 24px 0px;
    display: flex;
    justify-content: space-between;
    position: relative;
}
.swiper-container {
    width: 1128px;
}
.swiper-slide {
    height: 270px !important;
 }
 .swiper-slide .foodLogo {
    width: 300px;
    height: 225px;
    /* border: 1px solid #e5e5e5; */
    cursor: pointer;
}
.swiper-button-prev,
.swiper-button-next {
    width: 30px;
    height: 112px;
}
.swiper-button-prev {
    background-image: url(../../assets/image/indexNew/arrow.png) !important;
    background-size: contain;
    transform: rotate(180deg);
}
.swiper-button-next {
    background-image: url(../../assets/image/indexNew/arrow.png) !important;
}
.swiper-button-next {
    width: 40px;
    height: 112px;
    background: #F2F2F2;
    float:right;
}
.swipper-next,
.swipper-prev {
    width: 30px;
    height: 112px;
    background: #F2F2F2;
    margin-top: 56px;
}
.swipper-next p,
.swipper-prev p {
    line-height: 112px;
    text-align: center;
    color: #116EBA;
    cursor:pointer;
}
</style>
<style>
.highLight-item img {
    width: 290px;
    height: 164px;
}
.highLightImage{
    width:372px;
    height: 210px;
    cursor: pointer;
}
.highLightItem .group_title {
    margin-bottom: 0;
}
.highLightItem .group_title span{
    height: 45px;
    background: none;
    font-size: 18px;
    color: #262626;
    width: auto;
    border-bottom: none;
    padding: 0;
}
.fix_image_name{
    position: absolute;
    top: 0px;
    left:0;
    right:0;
    font-size: 20px;
    text-align: center;
    background: #116EBA;
    color: #ffffff;
    padding: 8px;
}
</style>